import UnknownResult from "./views/unknown";
import SignaltekSummaryResult from "./views/summaryv2/signaltekSummary";
import PingResult from "./views/ping";
import TraceRouteResult from "./views/traceroute";
import NetScanResult from "./views/netscan";
import WireMapResult from "./views/wiremapresult";
import PoeResult from "./views/poe";
import MaxthroughputResult from "./views/maxthroughput";
import UptimeResult from "./views/uptime";
import CustomDataResult from "./views/subtestsettings/customdata";
import CableDataResult from "./views/subtestsettings/cabledata";
import WebDataResult from "./views/subtestsettings/webdata";
import VoIPDataResult from "./views/subtestsettings/voipdata";
import VideoDataResult from "./views/subtestsettings/videodata";
import CCTVDataResult from "./views/subtestsettings/cctvdata";
import StatsResult from "./views/stats";
import FiberLengthLossResult from "./views/fiberlengthloss";
import QualificationResult from "./views/qualification";
import QtRfResult from "./views/qtrf"

const ResultMap = {
  Summary: SignaltekSummaryResult,
  Ping4: PingResult,
  Ping6: PingResult,
  TraceRoute4: TraceRouteResult,
  TraceRoute6: TraceRouteResult,
  NetScan: NetScanResult,
  WireMap: WireMapResult,
  PoeLoad: PoeResult,
  Maxthroughput: MaxthroughputResult,
  Uptime: UptimeResult,
  CustomData: CustomDataResult,
  CableData: CableDataResult,
  WebData: WebDataResult,
  VoIPData: VoIPDataResult,
  VideoData: VideoDataResult,
  CCTVData: CCTVDataResult,
  Stats: StatsResult,
  FiberLengthLoss: FiberLengthLossResult,
  Qualification: QualificationResult,
  unknown: UnknownResult,
  qualification_il: QtRfResult,
  qualification_rl: QtRfResult,
  qualification_next: QtRfResult
};

const GetSignaltekResultView = result => {
  return ResultMap.hasOwnProperty(result)
    ? ResultMap[result]
    : ResultMap["unknown"];
};

export default GetSignaltekResultView;
